import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { Container } from '@sm/wds-react';
import { HomeBottomCard } from '../HomeBottomCard';
import audienceImage from '../assets/Audience.png';
import solutionsImage from '../assets/Solutions.png';

const COPY = defineMessages({
  HEADLINE_MARKET_RESEARCH: {
    id: 'SolutionsCard.headlineMarketResearch',
    defaultMessage: 'Buy responses for your market research surveys',
    description:
      '[Type: Paragraph][Vis.: low] - Home bottom card market research headline',
  },
  MESSAGE_MARKET_RESEARCH: {
    id: 'SolutionsCard.messageMarketResearch',
    defaultMessage: 'Find people to take your survey at an affordable price.',
    description:
      '[Type: Paragraph][Vis.: low] - Home bottom card market research message',
  },
  CTA_TEXT_MARKET_RESEARCH: {
    id: 'SolutionsCard.ctaTextMarketResearch',
    defaultMessage: 'See pricing',
    description:
      '[Type: Button][Vis.: low] - Home bottom card market research cta text',
  },
  HEADLINE_CONCEPT_TESTING: {
    id: 'SolutionsCard.headlineFeedback',
    defaultMessage:
      'Get actionable insights using our market research platform',
    description:
      '[Type: Paragraph][Vis.: low] - Solutions card concept testing headline',
  },
  MESSAGE_CONCEPT_TESTING: {
    id: 'SolutionsCard.messageFeedback',
    defaultMessage:
      'Uncover market trends, test product ideas, and track your brand with expert methodologies.',
    description:
      '[Type: Paragraph][Vis.: low] - Solutions card concept testing message',
  },
  CTA_TEXT_CONCEPT_TESTING: {
    id: 'SolutionsCard.ctaTextFeedback',
    defaultMessage: 'Browse our solutions',
    description:
      '[Type: Button][Vis.: low] - Solutions card concept testing cta text',
  },
});

export const SolutionsCard: React.FC = () => {
  return (
    <Container flex flexJustify="between">
      <HomeBottomCard
        headline={t(COPY.HEADLINE_MARKET_RESEARCH)}
        message={t(COPY.MESSAGE_MARKET_RESEARCH)}
        image={() => (
          <img
            src={audienceImage}
            width={60}
            height="auto"
            aria-hidden="true"
          />
        )}
        ctaText={t(COPY.CTA_TEXT_MARKET_RESEARCH)}
        ctaLink={createURL('/collect/audience/calculator/preview', {
          ut_source: 'ucs',
          ut_source2: 'li_home',
          ut_source3: 'affordable-market-research-left',
          cvosrc: 'product.surveymonkey',
          cvo_campaign: 'li_home',
        })}
        ctaNewTab={true}
      />
      <HomeBottomCard
        headline={t(COPY.HEADLINE_CONCEPT_TESTING)}
        message={t(COPY.MESSAGE_CONCEPT_TESTING)}
        image={() => (
          <img
            src={solutionsImage}
            width={48}
            height="auto"
            aria-hidden="true"
          />
        )}
        ctaText={t(COPY.CTA_TEXT_CONCEPT_TESTING)}
        ctaLink={createURL('/market-research/solutions/', {
          ut_source: 'my_surveys',
        })}
        ctaNewTab={true}
      />
    </Container>
  );
};

export default SolutionsCard;
